import React, { useEffect, useState } from "react";
import DisplayArrow from "../../../Elements/DisplayArrow/DisplayArrow";
import { TDiversCartTotalInferiorModel } from "../types/DiversificacionCarteraTypes";
import { TDataActivo1, TDataActivo1y2, TDataMaxDetail } from "../Util/FormatTableData";
import { TooltipHost } from "@fluentui/react";



const BASE_CLASS = "tableCustom";

type TTableCustomProps = {
    tableData: TDataActivo1[]
    totalRowData: TDiversCartTotalInferiorModel
};

const TableCustom: React.FC<TTableCustomProps> = ({ tableData, totalRowData }) => {
  const localTheme = window.localStorage.getItem("theme") || "light";

  const maxLevelHeader = ["Tipo de Activo", "Peso", "Volatilidad", "Aportación al Riesgo con Correlación 1", "Aportación al Riesgo con Correlación Real", "Diferencia", "Beneficio de Diversificación", "Correlación"]

  const [expandedRows, setExpandedRows] = useState<Set<string>>(new Set());
  const [expandedMaxRows, setExpandedMaxRows] = useState<Set<string>>(new Set());



  const toggleExpand = (name: string, setState: Function) => {
    setState((prev: Set<string>) => {
      const newSet = new Set(prev);
      newSet.has(name) ? newSet.delete(name) : newSet.add(name);
      return newSet;
    });
  };

  useEffect(() => {
    setExpandedRows(new Set(tableData.map(row => row.name)));
    setExpandedMaxRows(new Set(tableData.flatMap(row => row.children?.map(child => child.name2) ?? [])));

  }, [tableData]);

  const renderExpanseMax = (data: TDataMaxDetail[]) => {
    return (
      <React.Fragment>
        {data.map((row) => (
          <React.Fragment key={row.name2}>
            <tr className={`${BASE_CLASS}__detail__row ${BASE_CLASS}__${localTheme}`} >
                <td className="expanse_cell">{row.data.nomInstrum}</td>
                <td>{row.data.peso}%</td>
                <td>{row.data.volatilidad}%</td>
                <td>{row.data.aportacionRiesgoCorrelacion}%</td>
                <td>{row.data.aportacionRiesgoCorrelacionReal}%</td>
                <td>{row.data.diferencia}%</td>
                <td>{row.data.beneficioDiversificacion}%</td>
                <td>{row.data.correlacion}</td>
            </tr>
          </React.Fragment>
        ))}
        </React.Fragment>
      )
  };

  const renderExpanse = (data: TDataActivo1y2[]) => {
    return (
      <React.Fragment>
        {data.map((row) => (
          <React.Fragment key={row.name2}>
              <tr onClick={() => toggleExpand(row.name2, setExpandedMaxRows)}>
                  <td className="expanse_cell">
                    {row.children && row.children.length > 0 ? <DisplayArrow expanded={expandedMaxRows.has(row.name2)} /> : ""}
                    {row.data.tipoActivo2}
                  </td>
                  <td>{row.data.totalPeso}%</td>
                  <td></td>
                  <td>{row.data.volatilidadCorrelacion1}%</td>
                  <td>{row.data.volatilidadCorrelacionReal}%</td>
                  <td>{row.data.totalDiferencia}%</td>
                  <td></td>
                  <td></td>
              </tr>
              {expandedMaxRows.has(row.name2) && row.children && (
                <>{renderExpanseMax(row.children)}</>
              )}
          </React.Fragment>

        ))}
        </React.Fragment>
      )
  };

  const renderRows = (data: TDataActivo1[]) => {
    return data.map((row) => (
      <React.Fragment key={row.name}>
        <tr onClick={() => toggleExpand(row.name, setExpandedRows)}>
            <td>
              {row.children ? <DisplayArrow expanded={expandedRows.has(row.name)} /> : ""}
              {row.data.tipoActivo1}
            </td>
            <td>{row.data.totalPeso}%</td>
            <td></td>
            <td>{row.data.volatilidadCorrelacion1}%</td>
            <td>{row.data.volatilidadCorrelacionReal}%</td>
            <td>{row.data.totalDiferencia}%</td>
            <td></td>
            <td></td>
        </tr>
        {expandedRows.has(row.name) && row.children && (
          <>{renderExpanse(row.children)}</>
        )}
      </React.Fragment>
    ));
  };

  return (
    <div className={BASE_CLASS}>
        <table>
          <thead>
            <tr className={`${BASE_CLASS}__${localTheme}`}>
                <th className="first">
                  <TooltipHost content={maxLevelHeader[0]}>
                    <div>{maxLevelHeader[0]}</div>
                  </TooltipHost>
                </th> 
                <th>
                  <TooltipHost content={maxLevelHeader[1]}>
                    <div>{maxLevelHeader[1]}</div>
                  </TooltipHost>
                </th>
                <th>
                  <TooltipHost content={maxLevelHeader[2]}>
                    <div>{maxLevelHeader[2]}</div>
                  </TooltipHost>
                </th>
                <th>
                  <TooltipHost content={`${maxLevelHeader[3]} es el resultado de multiplicar el Peso por la Volatilidad.`}>
                    <div>Apt. Riesgo Corr 1</div>
                  </TooltipHost>
                </th>
                <th>
                  <TooltipHost content={`${maxLevelHeader[4]} es el resultado de multiplicar el Peso por la Volatilidad y por la Correlación.`}>
                    <div>Apt. Riesgo Corr Real</div>
                  </TooltipHost>
                </th>
                <th>
                  <TooltipHost content={`${maxLevelHeader[5]} es el resultado de la Aportación al Riesgo con Correlación 1 menos Aportación al Riesgo con Correlación Real.`}>
                    <div>{maxLevelHeader[5]}</div>
                  </TooltipHost>
                </th>
                <th>
                  <TooltipHost content={`${maxLevelHeader[6]} es el resultado de 1 menos Correlación.`}>
                    <div>Benef. Divers.</div>
                  </TooltipHost>
                </th>
                <th>
                  <TooltipHost content={`${maxLevelHeader[7]}`}>
                    <div>{maxLevelHeader[7]}</div>
                  </TooltipHost>
                </th>
            </tr>
          </thead>
        <tbody>
          <tr>
            <td className={`${BASE_CLASS}__bold`}>Totales</td>
            <td>{totalRowData.totalPeso}%</td>
            <td></td>
            <td>{totalRowData.volatilidadCorrelacion1}%</td>
            <td>{totalRowData.volatilidadCorrelacionReal}%</td>
            <td>{totalRowData.totalDiferencia}%</td>
            <td></td>
            <td></td>
          </tr>
          {renderRows(tableData)}
        </tbody>
      </table>
    </div>
  );
};

export default TableCustom;